import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { RDataPracticeViewModel } from '../../api/models';
import { ContractDataCardComponent } from '../../components/contract-data-card/contract-data-card.component';
import { PageHeadingComponent } from '../../components/page-heading/page-heading.component';
import { RDataService } from '../../services/rdata.service';
import { ResolveLibModule, RdataDetailsComponent } from 'resolve-lib';
import { PageWellComponent } from "../../components/page-well/page-well.component";
import { ScrollerService } from '../../services';

@Component({
    selector: 'app-rdata-contract-details-page',
    templateUrl: './rdata-contract-details.component.html',
    styleUrls: ['./rdata-contract-details.component.scss'],
    imports: [
        ResolveLibModule,
        PageHeadingComponent,
        CommonModule,
        RdataDetailsComponent,
        PageWellComponent
    ]
})
export class RDataContractDetailsPage implements OnInit {
  contractDetails: Observable<RDataPracticeViewModel> | null = null;

  constructor(
    private rDataService: RDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private scrollerService: ScrollerService
  ) {}

  ngOnInit() {
    const id = this.activatedRoute.snapshot.paramMap.get('id') || '';
    this.contractDetails = this.rDataService.getRDataRecord(id);
    this.scrollerService.scrollToTop();
  }

  goBackToRDataRecordsPage() {
    this.router.navigate(['/rdata-records'], {
      relativeTo: this.activatedRoute,
    });
  }
}
